import React from 'react';
import { Icon } from 'rsuite';

export const Step5 = ({cliente}) => {
    return (
        <div className="row">
            <div className="col-12">
                <div className="text-center">
                    <h2 className="mt-0">
                        <i className="fa fa-check fa-2x"></i>
                    </h2>
                    <h3 className="mt-0">Ficha de pago creada!</h3>
                    <h5 className="mb-2">Recuerda que tu ficha de pago tiene una <span className="text-warning">vigencia de un día</span>.</h5>
                <p className="mb-5">*Despues de realizar tu pago te mandaremos un correo electronico con las indicaciones para acceder a tu cuenta, esto puede tardar hasta un día habil para verse reflejado.</p>
                </div>
                <div className="row">
                    {/* <div className="col-6">
                        <a 
                            href={`${process.env.REACT_APP_API_URL}/pdf/pagoEfectivo/d/${cliente.method}/${cliente.payment_id}`}
                            className="btn btn-outline-primary btn-lg btn-block" 
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Icon icon="download" /> Descargar
                        </a>
                    </div> */}
                    <div className="col text-center">
                        <a 
                            href={`${process.env.REACT_APP_API_URL}/pdf/pagoEfectivo/${cliente.method}/${cliente.payment_id}`}
                            className="btn btn-outline-primary btn-lg" 
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Icon icon="print" /> Imprimir / Descargar
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
